import React            from 'react';
import SplitViewContext from '@widesk-ui/contexts/SplitViewContext';

export default function useSplitView() {
	return React.useContext(SplitViewContext);
}
